import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  popUpOuter: {
    "& .Mui-disabled": {
      opacity: "0.6 !important",
      color: "#fff  !important",
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "600px",
      overflow: "initial",
    },
    "& .MuiDialogTitle-root ": {
      flex: "0 0 auto",
      margin: "0",
      position: "relative",
      padding: "16px 24px",
      //z-index: '1',
    },
    "& .MuiOutlinedInput-input": {
      float: "left !important",
      width: "100% !important",
      padding: "10px 2px !important",
      background: "#f7fcff",
      borderRadius: "4px",
    },
    "& .MuiFormControl-marginNormal": {
      marginTop: "3px",
      marginBottom: "8px"
    }
  },
  switchDiv: {
    float: "left",
    margin: "-10px 0 0 0",
  },
  compDisableCls: {
    opacity: 0.9,
    pointerEvents: "none",
  },
  popUpVendorSearch: {
    "& .Mui-disabled": {
      opacity: "0.6 !important",
      color: "#fff  !important",
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "650px",
      overflow: "initial",
    },
    "& .MuiDialogTitle-root ": {
      flex: "0 0 auto",
      margin: "0",
      position: "relative",
      padding: "16px 24px",
      //z-index: '1',
    },
    "& .MuiOutlinedInput-input": {
      float: "left !important",
      width: "100% !important",
      padding: "10px 2px !important",
      background: "#f7fcff",
      borderRadius: "4px",
    },
  },

  popUpHeader: {
    backgroundImage: "linear-gradient(to right, #890e34, #ce0623)",
    padding: "14px 12px 10px 24px !important",
    borderRadius: "0px 0px 0 0",
    "& h2": {
      color: "#fff",
      fontWeight: "normal",
      textTransform: "uppercase",
      position: "relative",
    },
  },

  NoPopWrapper: {
    //padding: '20px 120px 20px 25px',
    "& .MuiOutlinedInput-input": {
      float: "left",
      width: "100%",
      padding: "10px 0 10px 2px",
      background: "#f7fcff",
      borderRadius: "4px",
    },
    "& .MuiFormControl-root": {
      margin: "0 10px 0 0",
    },
  },

  popUpLBL: {
    textTransform: "uppercase",
    fontSize: "12px",
    margin: "0 2px 0 0",
  },
  popUpAddBtn: {
    "& .MuiSvgIcon-root": {
      color: "#28b600",
      float: "left",
    },
  },
  popdataRow: {
    "& .MuiFormControl-root": {
      background: "#f7fcff",
    },
    "& .MuiOutlinedInput-multiline": {
      padding: "5px 5px",
    },
  },

  addBtnWrapper: {
    float: "left",
    margin: "0px 0px 0 10px",
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
    },
    "& .MuiButton-text": {
      padding: "4px 6px",
    },
    "& .MuiButton-root:hover": {
      background: "#00b50a !important",
      fontSize: "12px",
      color: "#fff",
    },
  },

  greenBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      color: "#fff",
      fontSize: "12px",
      background: "#00b50a !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },

  blueBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#0faade !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#0178e7 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },

  searchBtnWrapper: {
    float: "right",
    //margin: '30px 0px 0px 0px',
    // [theme.breakpoints.down("sm")]: {
    //     float: 'right',
    //   },
    // [theme.breakpoints.down("sm")]: {
    //     float: 'right',
    //   },

    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      color: "#fff",
      fontSize: "12px",
      background: "#00b50a !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },

  textWrap: {
    width: "100%",
    //padding: '12px 0 4px 0',
    // padding: '12px 0 4px 0',
    background: "#fff",
    // minHeight: '21px',
    textAlign: "left",
    //fontWeight: 'bold',
    fontSize: "14px",
    textTransform: "uppercase",
    float: "left",
    //border:'1px solid #ddd',
    borderRadius: "4px",
    marginTop: "10px",
  },

  grayBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
    },
  },

  inputWrapper: {
    margin: "10px 0 10px 0",
    //float: "left",
    width: "100%",
    "& .MuiInputBase-root": {
      borderRadius: "4px",
      //border: '1px solid #c0c1c1',
      padding: "0px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 5px",
      textAlign: "left",
      maxHeight: "20px",
    },
    "& .MuiInput-root": {
      position: "relative",
      width: "100%",
      border: "1px solid #ccc !important",
      borderRadius: "4px",
      padding: "4px 0",
      background: "#f7fcff",
      float: "left",
    },

    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "unset",
      //margin: '2px',
      width: "100%",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "13px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    // "& input":{
    //              borderRadius: '4px',
    //              border: '1px solid #c0c1c1',
    //              padding: '8px 0',
    //              width:'100%',
    //             background:'#f7fcff',
    //              float: 'left',
    //          },
    "& select": {
      borderRadius: "4px",
      border: "1px solid #c0c1c1",
      padding: "12px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .makeStyles-root-25 .MuiIconButton-root": {
      padding: "4px 0",
    },
    "& .MuiList-padding": {
      paddingTop: "10px !important",
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "#7f7f7f",
    },
    "& .MuiChip-root.Mui-disabled": {
      color: "#7f7f7f",
    },
  },

  inputWrapper_Req: {
    margin: "10px 0 10px 0",
    "& .MuiChip-root": {
      height: "23px",
    },
    "& .MuiInputBase-root": {
      borderRadius: "4px",
      //border: '1px solid #c0c1c1',
      padding: "0px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 5px",
      borderRight: "5px solid #ed1c24",
      borderRadius: "0 4px 4px 0",
      textAlign: "left",
      maxHeight: "20px",
    },
    "& .MuiInput-root": {
      position: "relative",
      width: "100%",
      border: "1px solid #ed1c24 !important",
      borderRadius: "4px",
      padding: "4px 0",
      background: "#f7fcff",
      float: "left",
      borderRight: "5px solid #ed1c24 !important",
    },
    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "unset",
      //margin: '2px',
      width: "100%",
      marginTop:"2px"
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']":
      {
        paddingRight: "0px",
      },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "13px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    "& select": {
      borderRadius: "4px",
      border: "1px solid #c0c1c1",
      padding: "12px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
      borderRight: "5px solid #ed1c24 !important",
    },
    "& .makeStyles-root-25 .MuiIconButton-root": {
      padding: "4px 0",
    },
    "& .MuiList-padding": {
      paddingTop: "10px !important",
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "#7f7f7f",
    },
    "& .MuiChip-root.Mui-disabled": {
      color: "#7f7f7f",
    },
  },
  filterheader: {
    fontSize: "14px",
    margin: "16px 0 0 0 !important",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  createLbl: {
    textAlign: "left",
    float: "left",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    margin: "0 0 2px 0",
    width: "100%",
  },
  tblOuterBG: {
    backgroundColor: "#fff;",
    padding: "10px",
    borderRadius: "15px",
  },
  tblContainer: {
    maxHeight: "200px",
    minHeight: "200px",
  },

  tblHeader: {
    "& th": {
      //  backgroundColor:'#fbfbfb',
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "14px",
      padding: "10px 5px !important",
      fontWeight: "bold",
    },
  },
  tblBody: {
    "& th": {
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "14px",
      padding: "6px 5px !important",
      fontWeight: "bold",
    },
    "& td": {
      color: "#000",
      backgroundColor: "#fff;",
      fontSize: "14px",
      padding: "6px 5px !important",
      textTransform: "uppercase",
      borderBottom: "1px solid #ededed !important",
    },
  },
  chiproot: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: "10px",
  },
  chip: {
    margin: theme.spacing(0.5),
  },

  inputGridItem: {
    margin: "10px 0px 10px",
    width: "100%",
    float: "left",
  },

  
  fileWrapper:{
   // margin: '16px 0 0 0',
      "& input"  :{
            background:'#ccc',
        },
        "& input[type='file']":{
            float: 'left',
            padding: '10px 2px',
            background: '#f7fcff',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '51%',
        },
        "& .MuiButton-contained.Mui-disabled":{
            backgroundColor: '#05ae2a !important',
            color: '#fff',
            padding: '2px 10px !important',
            margin: '8px 0 0 5px',
            float:'left',
        },
        "& .MuiButton-containedPrimary":{
            backgroundColor: '#05ae2a !important',
            color: '#fff',
            padding: '2px 10px !important',
            margin: '8px 0 0 5px', 
            float:'left',
        },
        "& a":{
            background: '#00a4dd',
            textDecoration: 'none',
            color: '#fff',
            margin: '7px 0 0 5px',
            padding: '6px 7px 7px 6px',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontSize: '14px',
            float:'left',
        },
    },
    infoLabel: {
      border: "1px solid #FF9F07",
      borderRadius: "5px",
      background: "#c3e1f6",
      fontSize: "12px",
      fontWeight: "bold",
      padding:"2px 8px",
      marginLeft: "0px",
    },
    helpLbl: {
      textAlign: 'left',
      float: 'left',
      fontSize: '12px',
      color: '#02268b',
      fontStyle: 'italic',
      margin: '0 0 2px 0',
    },
    popUpHeaderTxt:{
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: '16px',
        textAlign:'left',
    },
    popUpHeaderLine:{
        height: '2px',
        margin: '8px 0 0 5px',
        display: 'flex',
        padding: '0 !important',
        minWidth: '81%',
        background: '#e2e2e2',
    
    }
}));

export default useStyles;
